type Props = {
  children: React.ReactNode;
  className?: string;
};

export function Section({ children, className }: Props) {
  return (
    <section id="blog-posts" className="blog-posts section">
      <div className="container">
        <div className={`row ${className || ''}`}>{children}</div>
      </div>
    </section>
  );
}
